angular.module('etCopy', []);